import { render, staticRenderFns } from "./LeaveHospital.vue?vue&type=template&id=5b48d055&scoped=true"
import script from "./LeaveHospital.vue?vue&type=script&lang=js"
export * from "./LeaveHospital.vue?vue&type=script&lang=js"
import style0 from "./LeaveHospital.vue?vue&type=style&index=0&id=5b48d055&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b48d055",
  null
  
)

export default component.exports